import { render, staticRenderFns } from "./LandingPreEvento.vue?vue&type=template&id=1968f475&scoped=true"
import script from "./LandingPreEvento.vue?vue&type=script&lang=js"
export * from "./LandingPreEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1968f475",
  null
  
)

export default component.exports